<app-review-comments
	*ngIf="(state == STATE.EDITING || state === STATE.VIEWING) && reviewComments && !activatedRoute.snapshot.params.state"
	[reviewCommentsOptions]="reviewCommentsOptions" [disable]=true [withoutSubmit]="true" [withoutCancel]="true"
	[reviewComments]="reviewComments"></app-review-comments>

<app-d-form-group [fnBuffer]="inforFormFnBuffer"
	[disable]="reviewingOrViewing && !disable || isAdmin || disableWhenApproved" *ngIf='formData'
	(control)="infoFormControl = $event" [formArray]="forms" [(defaultValues)]="data.infoForm"
	[(formData)]="data.infoForm" (submit)="onSubmit($event)" (validChange)="validity.infoForm = $event"
	(cancel)="onCancel($event)"></app-d-form-group>
<!-- <app-address-form [disable]="isAdmin" state='ANDAMAN AND NICOBAR ISLAND' district="NICOBAR" tehsil='a' (completeAddressChange)="data.address = $event"
 parliamentary='a' [formGroupRef]="addressForm" [defaultAddress]=""></app-address-form> -->

<app-address-form [options]="addressOptions" *ngIf='formData' [validationCheck]="validationCheck"
	[(valid)]="validity.addressForm" [disable]="isAdmin || disableWhenApproved" [completeAddress]="data.address"
	(completeAddressChange)="data.address = $event" [tcState]="state" [isJssScheme]="forJSS" [state]="tpState" [district]="tpDistrict"></app-address-form>
<app-facility-select-upload-adding-tc [validationCheck]="validationCheck" *ngIf='formData && facilityOptions && !isIndiaSkillsScheme'
	[showAstrisk]=false [requiredFacilites]="requiredFacilities" [options]="facilityOptions"
	[defaultValue]='trainingCentre.feebasedFacilities' [disable]="disableWhenApproved" [state]="state"
	(validChange)="validity.facilityForm = $event" (valueChange)="data.facilityForm = $event">
</app-facility-select-upload-adding-tc>
<!-- <app-d-form-group *ngIf='formData' [disable]="reviewingOrViewing" [formArray]="facilityForms" [defaultValues]="data.facilityForm" (formDataChange)="data.facilityForm = $event"
 (validChange)="validity.factrainingCenterTypeilityForm = $event" (submit)="onSubmit($event)" (cancel)="onCancel($event)"></app-d-form-group> -->
<app-d-form-group *ngIf='formData' [disable]="reviewingOrViewing && !disable || isAdmin || disableWhenApproved"
	[fnBuffer]="buffer.spocFormFnBuffer" [formArray]="spocForm" (control)="spocFormControl = $event"
	[(defaultValues)]="data.spocForm" [(formData)]="data.spocForm" (validChange)="validity.spocForm = $event"
	(submit)="onSubmit($event)" (cancel)="onCancel($event)"></app-d-form-group>
  <!-- Added infrastructure images section for JSS -->
  <div *ngIf="forJSS && !isIndiaSkillsScheme">
    <button class="open-accordion">Infrastructure Images<span class="red">*</span></button>
    <div class="open-panel">
      <div class="row">
        <form class="col-lg-12 row" [formGroup]="documents">
          <div class="form-group col-lg-3" style="padding: 30px">
            <label for="recipient-name" class="form-control-label">
              Upload Image 1:-<span class="red">*</span>
            </label>
            <div class="">
              <app-file-upload [fileValidation]="fileType" [multiColumn]="12"
                (fileUploaded)="fileUploaded($event, 'imageOne')"
                (fileUploadCancelled)="onFileUploadCancel($event, 'imageOne')">
              </app-file-upload>
            </div>
            <input type="hidden" formControlName="imageOne" readonly>
          </div>
          <div class="form-group col-lg-3" style="padding: 30px">
            <label for="recipient-name" class="form-control-label">
              Upload Image 2:-<span class="red">*</span>
            </label>
            <div class="">
              <app-file-upload [fileValidation]="fileType" [multiColumn]="12"
                (fileUploaded)="fileUploaded($event, 'imageTwo')"
                (fileUploadCancelled)="onFileUploadCancel($event, 'imageTwo')">
              </app-file-upload>
            </div>
            <input type="hidden" formControlName="imageTwo" readonly>
          </div>
          <div class="form-group col-lg-3" style="padding: 30px">
            <label for="recipient-name" class="form-control-label">
              Upload Image 3:-<span class="red">*</span>
            </label>
            <div class="">
              <app-file-upload [fileValidation]="fileType" [multiColumn]="12"
                (fileUploaded)="fileUploaded($event, 'imageThree')"
                (fileUploadCancelled)="onFileUploadCancel($event, 'imageThree')">
              </app-file-upload>
            </div>
            <input type="hidden" formControlName="imageThree" readonly>
          </div>
          <div class="form-group col-lg-3" style="padding: 30px">
            <label for="recipient-name" class="form-control-label">
              Upload Image 4:-<span class="red">*</span>
            </label>
            <div class="">
              <app-file-upload [fileValidation]="fileType" [multiColumn]="12"
                (fileUploaded)="fileUploaded($event, 'imageFour')"
                (fileUploadCancelled)="onFileUploadCancel($event, 'imageFour')">
              </app-file-upload>
            </div>
            <input type="hidden" formControlName="imageFour" readonly>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div *ngIf="isAdmin && imgDocs && !isIndiaSkillsScheme">
    <button class="open-accordion">Infrastructure Images<span class="red">*</span></button>
    <div class="open-panel">
      <div class="row">
        <div class="col-lg-12 row">
          <div class="form-group col-lg-3" style="padding: 30px">
            <label for="recipient-name" class="form-control-label">
              Uploaded Image 1:-<span class="red">*</span>
            </label>
            <div>
              <a href="{{imgDocs.imageOne}}" target="_blank">Image-1<img class="icon"
                  src="assets/images/icons8-download-24.png" alt=""></a>
            </div>
          </div>
          <div class="form-group col-lg-3" style="padding: 30px">
            <label for="recipient-name" class="form-control-label">
              Uploaded Image 2:-<span class="red">*</span>
            </label>
            <div>
              <a href="{{imgDocs.imageTwo}}" target="_blank">Image-2<img class="icon"
                  src="assets/images/icons8-download-24.png" alt=""></a>
            </div>
          </div>
          <div class="form-group col-lg-3" style="padding: 30px">
            <label for="recipient-name" class="form-control-label">
              Uploaded Image 3:-<span class="red">*</span>
            </label>
            <div>
              <a href="{{imgDocs.imageThree}}" target="_blank">Image-3<img class="icon"
                  src="assets/images/icons8-download-24.png" alt=""></a>
            </div>
          </div>
          <div class="form-group col-lg-3" style="padding: 30px">
            <label for="recipient-name" class="form-control-label">
              Uploaded Image 4:-<span class="red">*</span>
            </label>
            <div>
              <a href="{{imgDocs.imageFour}}" target="_blank">Image-4<img class="icon"
                  src="assets/images/icons8-download-24.png" alt=""></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<app-add-sector-target *ngIf="!isIndiaSkillsScheme" [state]="state" [disable]="disableWhenApproved" [selectedSchemeId]="selectedSchemeId"
	[trainingCentreName]="trainingCentre.trainingCentreName" [(selectedSectorTargets)]="sectorTargets"
	(validChange)="validity.sectorTargetForm = $event">
</app-add-sector-target>
<!-- tp add tc new flow -->
<app-view-tc-photos-through-mobile-apk-review-and-submit *ngIf="isAdmin" [amdinNstate]="amdinNstate"
	(reviewDataPhotos)="getPhotosReview($event)"></app-view-tc-photos-through-mobile-apk-review-and-submit>
<!-- <ng-container *ngIf="reviewingOrViewing && disable">
	<app-review-comments [reviewCommentsOptions]="reviewCommentsOptions" [exceptComment]="exceptCommentValidation"
		(submit)="onReviewSubmit($event)" (cancel)="onReviewCancel($event)"></app-review-comments>
</ng-container> -->
<div *ngIf="trainingCentre.status === 'Document Required'">
	<label class="m-checkbox m-checkbox--solid m-checkbox--state-brand">
		<input type="checkbox" (change)="checkBox($event, trainingCentre.status)" name="confirmation">
		I agree that necessary modifications have been made as directed, adhering to the compliance.
		<span></span>
	</label>
</div>

<ng-container *ngIf="state === STATE.FILLING && disable">
	<button type="button" class="btn btn-next" [disabled]="isClicked" (click)="onSubmit()">
		Save & Continue
		<!-- Submit -->
	</button>
	<button class="btn btn-secondary" (click)="onCancel()">
		Cancel
	</button>
</ng-container>
<ng-container *ngIf="state === STATE.EDITING && disable">
	<button type="button" class="btn btn-next" [disabled]="isValid || isClicked" (click)="onResubmit()">
		Save & Continue
	</button>
	<button class="btn btn-secondary" (click)="onCancel()">
		Cancel
	</button>
</ng-container>

<!-- <ng-container *ngIf="state === STATE.EDITING && disable && disableWhenApproved">
	<button type="button" class="btn btn-next" (click)="onNavigate()">
		Save & Continue
	</button>
	<button class="btn btn-secondary" (click)="onCancel()">
		Cancel
	</button>
</ng-container> -->

<ng-container *ngIf="state === STATE.VIEWING">
	<button class="btn btn-secondary" (click)="onCancel()">
		Cancel
	</button>
</ng-container>


<div class="modal fade" id="verify-otp" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          Verify OTP
        </h5>
        <button type="button" class="close" aria-label="Close" #closeModel data-dismiss="modal">
          <span aria-hidden="true">
            &times;
          </span>
        </button>
      </div>
      <div class="modal-body">
        <form class="m-form m-form--fit m-form--label-align-right" [formGroup]="verifyOTPForm">
          <div class="form-group m-form__group row">
            <label for="tp-details" class="col-3 col-form-label">
              Enter Mobile One Time Password:
              <span class="mandatoryColor">*</span>
            </label>
            <div class="col-9">
              <input class="form-control m-input" type="text" formControlName="mobileOTP"
                placeholder="Enter mobile one time password" maxlength="6">
              <app-form-control-messages [control]="verifyOTPForm.controls.mobileOTP"
                [name]="'Mobile One Time Password'"></app-form-control-messages>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label for="tp-details" class="col-3 col-form-label">
              Enter Email One Time Password:
              <span class="mandatoryColor">*</span>
            </label>
            <div class="col-9">
              <input class="form-control m-input" type="text" formControlName="emailOTP"
                placeholder="Enter email one time password" maxlength="6">
              <app-form-control-messages [control]="verifyOTPForm.controls.emailOTP" [name]="'Email One Time Password'">
              </app-form-control-messages>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-next verifybutton" (click)="verifyOTP()" [disabled]="verifyOTPForm.invalid">
          Verify
        </button>
        <button type="button" class="btn  btn-cancel" data-dismiss="modal">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>